import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  GET_ACCOUNT_STATUS,
  GET_INSIGHT_1,
  GET_ORDERS_DATA,
  GET_POPULAR_TIME,
  GET_SALES_DATA,
  GET_POPULAR_ITEMS_AND_CATEGORIES,
  RESET_DASHBOARD_STATE,
  SET_UPCOMING_CELEBRATIONS,
  SET_REPORT_STATUS,
  SET_GENERAL_DASH_STATS,
  SET_ACTIVE_CUSTOMER_LIFECYCLE_TEMPLATES,
} from "../types";

export const resetDashboardState = () => (dispatch) => {
  dispatch({
    type: RESET_DASHBOARD_STATE,
  });
};

export const setActiveCustLcTemplates = (activeIndex) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_CUSTOMER_LIFECYCLE_TEMPLATES,
    payload: activeIndex,
  });
};

export const getDashboardStatusCall = (store_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/${store_id}/status`)
      .then((res) => {
        dispatch({
          type: GET_ACCOUNT_STATUS,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getInsightCall1 = (id, isAllStores) => (dispatch) => {
  const url = isAllStores
    ? `/v1/groups/${id}/dashboard`
    : `/v1/insights/dashboard?storeId=${id}`;
  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        dispatch({
          type: GET_INSIGHT_1,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.status);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

// for todays highlight
export const getDashboardHighlights = (
  entityId,
  isAllStores,
  period,
  start,
  end,
  isExporting,
  orderType
) => {
  const url = isAllStores
    ? `/v1/groups/${entityId}/dashboard/highlights?period=${period}&start=${start}&end=${end}${
        orderType?.length > 0 ? `&order_type=${orderType}` : ""
      }${isExporting ? "&attachment=true" : ""}`
    : `/v1/insights/dashboard/highlights?storeId=${entityId}&period=${period}&start=${start}&end=${end}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(isExporting ? res : res?.data?.payload))
      .catch((err) => reject(err));
  });
};

export const exportCustomerBreakdown = (id, period, start, end) => {
  const url = `/v1/groups/${id}/dashboard/highlights?period=${period}&start=${start}&end=${end}&breakdownattachment=true`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(res.data))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getUniqCustForValidOrders = (
  entityId,
  period,
  start,
  end,
  orderType
) => {
  const url = `/v1/insights/dashboard/unique-customer-count/${entityId}?period=${period}&start=${start}&end=${end}${
    orderType?.length > 0 && orderType !== "all"
      ? `&order_type=${orderType}`
      : ""
  }&is_blocked=false`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => reject(err));
  });
};

export const fetchRejectedBills = (query) => {
  const page = query?.page || 1;
  const type = query?.type || "";
  const entityId = query?.entityId || "";
  const isExportQuery = query?.isAttachment || false;
  const orderType =
    query?.orderType === "all"
      ? ""
      : query?.orderType?.length > 0
      ? query?.orderType
      : "";

  const period = query.period?.key;
  const end = query.period?.endDate?.format("YYYY-MM-DD");
  const start = query.period?.startDate?.format("YYYY-MM-DD");

  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/insights/${entityId}/customer/rejected-bill/activity?page=${page}&period=${period}&start=${start}&end=${end}${
        type?.length ? `&type=${type}` : ""
      }${orderType?.length > 0 ? `&order_type=${orderType}` : ""}${
        isExportQuery ? "&attachment=true" : ""
      }`
    )
      .then((res) => resolve(isExportQuery ? res : res?.data?.payload))
      .catch((err) => reject(err));
  });
};

export const getSalesDataCall =
  (store_id, period, start, end, isAllStores, groupId) => (dispatch) => {
    let url = isAllStores
      ? `/v1/groups/${groupId}/dashboard/sales${
          period ? `?period=${period}` : ""
        }${start ? `&start=${start}` : ""}${end ? `&end=${end}` : ""}`
      : `/v1/insights/dashboard/sales?storeId=${store_id}${
          period ? `&period=${period}` : ""
        }${start ? `&start=${start}` : ""}${end ? `&end=${end}` : ""}`;

    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: GET_SALES_DATA,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.status);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  };

export const getOrdersDataCall =
  (store_id, period, start, end, isAllStores, groupId) => (dispatch) => {
    let url = isAllStores
      ? `/v1/groups/${groupId}/dashboard/orders${
          period ? `?period=${period}` : ""
        }${start ? `&start=${start}` : ""}${end ? `&end=${end}` : ""}`
      : `/v1/insights/dashboard/orders?storeId=${store_id}${
          period ? `&period=${period}` : ""
        }${start ? `&start=${start}` : ""}${end ? `&end=${end}` : ""}`;

    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: GET_ORDERS_DATA,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.status);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  };

export const getGeneralDashboardStats = (entityId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/${entityId}/dashboard/general-statistics`)
      .then((res) => {
        dispatch({
          type: SET_GENERAL_DASH_STATS,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.status);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getPopularTimes = (store_id, period, start, end) => (dispatch) => {
  let url =
    period === "custom"
      ? `/v1/insights/dashboard/popular?storeId=${store_id}&period=${period}&start=${start}&end=${end}`
      : `/v1/insights/dashboard/popular?storeId=${store_id}&period=${period}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        dispatch({
          type: GET_POPULAR_TIME,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.status);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getPopularItemsAndCategories = (store_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/dashboard/popular-items/${store_id}`)
      .then((res) => {
        dispatch({
          type: GET_POPULAR_ITEMS_AND_CATEGORIES,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.status);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getUpcomingCelebrations = (data, query) => (dispatch) => {
  const end = query?.period?.endDate?.format("YYYY-MM-DD");
  const start = query?.period?.startDate?.format("YYYY-MM-DD");

  return new Promise((resolve, reject) => {
    Api.post(
      `/v2/insights/dashboard/upcoming-celebrations?period=custom&start=${start}&end=${end}`,
      data
    )
      .then((res) => {
        if (data?.attachment) return resolve(res?.data);
        else
          dispatch({
            payload: res?.data?.payload,
            type: SET_UPCOMING_CELEBRATIONS,
          });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getUpcomingCelebrationsForMonth = (data, query) => () => {
  const page = query?.page || 1;
  const end = query?.period?.endDate?.format("YYYY-MM-DD");
  const start = query?.period?.startDate?.format("YYYY-MM-DD");

  return new Promise((resolve, reject) => {
    Api.post(
      `v2/insights/dashboard/upcoming-celebrations-for-month?page=${page}&period=custom&start=${start}&end=${end}`,
      data
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getReportStatus = (entityId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/dashboard/email-report-status/${entityId}`)
      .then((res) => {
        dispatch({
          type: SET_REPORT_STATUS,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const updateReportStatus = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/insights/dashboard/activate-email-report`, data)
      .then((res) => {
        dispatch({
          type: SET_REPORT_STATUS,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};
